export default "__VITE_ASSET__6ea48fe8__"